/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



(function ($, window) {
    "use strict";
    var revivJs = {
        m: function () {
            revivJs.d();
            revivJs.methods();
        },
        d: function () {
            this._window = $(window);
            this._document = $(document);
            this._body = $("body");
            this._html = $("html");
        },
        methods: function () {
            this.slickActivation();
            this.accordionActivation();
        },
        // start slick activation
        slickActivation: function () {

            // card-slider start

            if ($(Window).width() < 768) {
                $('.card-slider__items').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                });
            }

            $('.card-slider__right-arrow').click(function () {
                $(this).parent().parent().find('.slick-slider').slick('slickNext');
            });


            if ($(Window).width() < 768) {
                $('.text-slider__items').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                });
            }

            $('.text-slider__right-arrow').click(function () {
                $(this).parent().parent().find('.slick-slider').slick('slickNext');
            });
            // card-slider end

        },
        // end slick activation




        // start accordion activation
        accordionActivation: function () {
            function initAccordion() {
                if ($(window).width() < 1024) {
                    $(".accordion__content").hide();
                    $(".accordion:first .accordion__content").show();
                    $(".accordion:first .accordion__title").addClass("active");

                    $(".accordion__title").off("click").on("click", function () {
                        if (!$(this).hasClass("active")) {
                            $(".accordion__content").slideUp(300);
                            $(".accordion__title").removeClass("active");
                            $(this).addClass("active").next(".accordion__content").slideDown(300);
                        } else {
                            $(this).removeClass("active").next(".accordion__content").slideUp(300);
                        }
                    });
                } else {
                    $(".accordion__content").show();
                    $(".accordion__title").removeClass("active").off("click");
                }
            }

            initAccordion();

            $(window).on("resize", function () {
                initAccordion();
            });
        },
        // End accordion activation


    };
    revivJs.m();
})(jQuery, window);


if ($(Window).width() < 768) {
    $('.inside__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
    $('.inside__right-arrow').click(function () {
        $(this).parent().parent().find('.slick-slider').slick('slickNext');
    });
}


$(".collapse-item__title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".collapse-item__content").slideUp();
    } else {
        $(".collapse-item__content").slideUp();
        $(".collapse-item__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".collapse-item__content").slideDown();
    }
})



// ---------------------cart start-----------------



$('.cart__product-add-items').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: false
});


// $(".hidden-tablet-and-up").on('click', function () {
//     $("body").addClass('cart-open');
// })
// $(".cart__top-cross-img").on('click', function () {
//     $("body").removeClass('cart-open');
// })
// ---------------------cart end-----------------





$('.main-product__img-poster').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.main-product__thumb',
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});
$('.main-product__thumb').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.main-product__img-poster',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    vertical: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                vertical: false,
            }
        },
    ]
});
$('.main-product__slider-next').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.main-product__slider-prev').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// Product page and cart

$(document).ready(function() {
    $('.dv-custom-cart-tigger').on('click', function(){
        $('.dv-custom-cart').addClass('active');
        $('.c_cart_drawer_overlay').addClass('active');
    })
    $('.c_cart_drawer_overlay').on('click', function(){
        $('.dv-custom-cart').removeClass('active');
        $(this).removeClass('active');
    })
    $('.cart__top-cross-img').on('click', function(){
        $('.dv-custom-cart').removeClass('active');
        $('.c_cart_drawer_overlay').removeClass('active');
    })
    $('#qty-plus').on('click', function() {
        let $input = $('#qtynumber');
        let currentVal = parseInt($input.val()) || 1;
        $input.val(currentVal + 1).trigger('change');
        updateDisplayedPrice();
        handleAddonQty()
    });
    $('#qty-minus').on('click', function() {
        let $input = $('#qtynumber');
        let currentVal = parseInt($input.val()) || 1;
        if (currentVal > 1) {
        $input.val(currentVal - 1).trigger('change');
        } else {
        $input.val(1).trigger('change');
        }
        updateDisplayedPrice();
        handleAddonQty()
    });


    // --- Upsell Cart Drawer Offer Logic ---
    $(document).on('click', '.product-offer-add-to-cart-button', function() {
        setTimeout(function() {
            cartUpdate();
        }, 800);
    });

    $(document).on('click', '.cart-drawer-upsell-offer .quantity__button', function(e) {
        e.preventDefault();
        
        var $input = $(this).closest('.quantity').find('input.upsell-cart-drawer-bold-quantity-input');
        var currentVal = parseInt($input.val()) || 1;
        
        if ($(this).attr('name') === 'plus') {
            $input.val(currentVal + 1);
        } else {
            if (currentVal > 1) {
                $input.val(currentVal - 1);
            }
        }
        
        $input.trigger('change');
    });


    var addQty = 1;
    let selectedVariantId = $('input[name="seram"]:checked').data('variantid');
    let selectedVariantPrice = $('input[name="seram"]:checked').data('price') || 0;
    let selectedVariantComPrice = $('input[name="seram"]:checked').data('comprice') || 0;
    $(document).on('change', 'input[name="seram"]', function () {
        var qtyVal = parseInt($('#qtynumber').val()) || 1;
        selectedVariantId = $(this).data('variantid');
        selectedVariantPrice = parseFloat($(this).data('price')) || 0;
        selectedVariantComPrice = parseFloat($(this).data('comprice')) || 0;
        addQty = parseInt($(this).attr('addonquantity'), 10) || 1;
        var setAddQty = Math.min(9, Math.max(1, addQty * qtyVal));
        $('.quantity-select').val(String(setAddQty));
        updateDisplayedPrice();
    });


    $(document).on('change', '.cproductaddon', function () {
        updateDisplayedPrice();
    });

    function handleAddonQty(){
        var multiplier = parseInt($('#qtynumber').val()) || 1;
        console.log('quantity is:' + multiplier);
        $('.quantity-select').each(function () {
        // var currentVal = parseInt($(this).val(), 10) || 0;
        var currentVal = addQty;
        var newVal = currentVal * multiplier;
        console.log('Addon qty:' + newVal);
        $(this).val(newVal).trigger('change');
        });
    }



    function formatMoney(cents) {
    const moneyFormat = window.Shopify?.currency?.active === 'USD' ? '${{amount}}' : '{{amount}}';
    let value = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', value);
    }
    function updateDisplayedPrice() {
        if (typeof window.updateTotalPrice === 'function') {
            window.updateTotalPrice();
            return;
        }
        const quantity = parseInt($('#qtynumber').val()) || 1;

        let totalPrice = selectedVariantPrice * quantity;
        let totalComPrice = selectedVariantComPrice * quantity;
        $('.cproductaddon:checked').each(function () {
            const addonQty = $(this).next().find('.quantity-select').val() || 1;
            const addonPrice = parseFloat($(this).data('price')) || 0;
            const totalAddonPrice = addonPrice * addonQty;
            totalPrice += totalAddonPrice;
            totalComPrice += totalAddonPrice;
        });

            var priceDiff = totalComPrice - totalPrice;
            var saveprice = priceDiff * 100 / totalComPrice;
            var formatSave = Math.round(saveprice);
            if(selectedVariantComPrice >= 1){
                $('.save-badge').show();
                $('.save-badge').text('Save ' + formatSave +'%');
            }else{
                $('.save-badge').text('');
                $('.save-badge').hide();
            }
            

        const formattedPrice = formatMoney(totalPrice * 100);
        const formattedComPrice = formatMoney(totalComPrice * 100);
        $('.prod-main-price span').text(formattedPrice);
        if(selectedVariantComPrice >= 1){
            $('.compare-price span').text(formattedComPrice);
        }else{
            $('.compare-price span').text('');
        }
        
        console.log(totalPrice)
        
    }

$('.quantity-select').on('change', function(){
    updateDisplayedPrice();
})




// Cart add on slider

    $(document).on('click', '.cart_addon_product_btn', function(e){
        e.preventDefault();
        var addOnId = $(this).data('addonid');
        if (!addOnId) {
            console.error("No addon ID found on button", this);
            return;
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({
                id: addOnId,
                quantity: 1
            }),
            dataType: 'json',
            contentType: 'application/json',
            success: function (data) {
                cartUpdate();
            },
            error: function (err) {
                console.error("Error adding Addon product:", err);
            }
        });
    });

    function cartAddonCheck() {
}


// Add to cart logic

// $('.addtocartbtn').on('click', async function(e) {
//     e.preventDefault();
//     const quantity = parseInt($('#qtynumber').val()) || 1;
//     if (!selectedVariantId) {
//         alert('Please select a product variant!');
//         return;
//     }
//     const mainProduct = {
//         id: selectedVariantId,
//         quantity: quantity,
//         properties: {}
//     };
//     $('.cproductproperties:checked').each(function() {
//         const key = $(this).data('properties-name');
//         const value = "(included)";
//         mainProduct.properties[key] = value;
//     });
//     const items = [
//         mainProduct
//     ];
//     $('.cproductaddon:checked').each(function() {
//         items.push({
//             id: $(this).data('addonid'),
//             quantity: $(this).next().find('.quantity-select').val(),
//             parent_id: selectedVariantId
//         });
//     });
//     try {
//         const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ items })
//         });
//         if (!response.ok) {
//             const error = await response.json();
//             console.error('Error adding items:', error);
//             return;
//         }
//         const data = await response.json();
//         cartUpdate();
//     } catch (err) {
//         console.error('AJAX error:', err);
//     }
// });

$('.addtocartbtn').on('click', async function(e) {
    e.preventDefault();
    if (typeof window.validateOptionsForm === 'function') {
        const ok = await window.validateOptionsForm();
        if (!ok) return;
    }
    // Ensure Key Options has fresh property payload before /cart/add.js
    if (typeof window.KeyOptions?.refreshProperties === 'function') {
        try {
            await window.KeyOptions.refreshProperties();
        } catch (err) {
            console.warn('Key Options refreshProperties failed:', err);
        }
    }
    const quantity = parseInt($('#qtynumber').val(), 10) || 1;
    if (!selectedVariantId) {
        alert('Please select a product variant!');
        return;
    }
    const addonItems = [];
    $('.cproductaddon:checked').each(function() {
        const $addon = $(this);
        const qty = parseInt($addon.next().find('.quantity-select').val(), 10) || 1;
        addonItems.push({
            id: $addon.data('addonid'),
            quantity: qty,
        });
    });
    try {
        // 1) Main product — flat FormData (Key Options injects option properties here)
        // Do not send PDP-only "(included)" labels as line-item properties;
        // Shopify Checkout always prints those as "Name: (included)".
        const fd = new FormData();
        fd.append('id', selectedVariantId);
        fd.append('quantity', quantity);
        const mainResponse = await fetch('/cart/add.js', {
            method: 'POST',
            body: fd,
            credentials: 'same-origin',
        });
        if (!mainResponse.ok) {
            const error = await mainResponse.json();
            console.error('Error adding main item:', error);
            return;
        }
        await mainResponse.json();
        // 2) Theme addons — plain lines (no parent_line_key / parent_id)
        // Cannot nest under a Key Options bundle parent in a 2nd request.
        if (addonItems.length > 0) {
            const addonResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ items: addonItems }),
            });
            if (!addonResponse.ok) {
                const error = await addonResponse.json();
                console.error('Error adding addon items:', error);
                return;
            }
            await addonResponse.json();
        }
        // Brief pause so Key nested priced lines can settle before drawer refresh
        setTimeout(function() {
            cartUpdate();
        }, 150);
    } catch (err) {
        console.error('AJAX error:', err);
    }
});






// Remove item from cart



$(document).on('click', '.cart__product-delete-img', function(e) {
  e.preventDefault();
  var itemKey = $(this).data('itemproductid');

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: itemKey, quantity: 0 },
    dataType: 'json',
    success: function(cart) {
      cartUpdate();
    },
    error: function(err) {
      console.error('Error removing item:', err);
    }
  });
});





// Cart Quantity Update logic
$(document).on('click', '.cart-qty-minus', function() {
  let input = $(this).siblings('.cart-qty-input');
  let currentQty = parseInt(input.val()) || 1;
  let newQty = Math.max(1, currentQty - 1);
  input.val(newQty).trigger('change');
});
$(document).on('click', '.cart-qty-plus', function() {
  let input = $(this).siblings('.cart-qty-input');
  let currentQty = parseInt(input.val()) || 1;
  let newQty = currentQty + 1;
  input.val(newQty).trigger('change');
});
$(document).on('change', '.cart-qty-input', function() {
  let newQty = parseInt($(this).val()) || 1;
  let itemKey = $(this).data('itemkey');
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: itemKey, quantity: newQty },
    dataType: 'json',
    success: function(cart) {
      cartUpdate();
    },
    error: function(err) {
      console.error('Error updating quantity:', err);
    }
  });
});


// Cart Update Logic

function escapeCartHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Key Options hides priced values from visible properties; expand full list from _key_all_property_values
// and append pack addon qty (1x/2x/3x) from _key_variant_quantities when present.
// Those quantities are per parent unit. Nested checkout lines already multiply by
// parent line qty; the drawer must do the same or options stay at Qty 1.
function getParentLineQty(el) {
  var fromAttr = parseInt(el.getAttribute('data-item-quantity'), 10);
  if (Number.isFinite(fromAttr) && fromAttr > 0) return fromAttr;

  var input = el.querySelector(
    '.cart-qty-input, .QuantitySelector__CurrentQuantity, input[name="quantity"]'
  );
  var fromInput = parseInt(input && input.value, 10);
  if (Number.isFinite(fromInput) && fromInput > 0) return fromInput;

  return 1;
}

function parseKeyCartEntries(el) {
  var raw = el.getAttribute('data-key-all-options');
  if (!raw) return [];
  var decoded = raw
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&');
  var entries;
  try {
    entries = JSON.parse(decoded);
  } catch (err) {
    return [];
  }
  if (!Array.isArray(entries) || !entries.length) return [];

  var qtyByVariantId = {};
  var packQty = 1;
  var parentQty = getParentLineQty(el);
  var idsRaw = el.getAttribute('data-key-variant-ids') || '';
  var qtysRaw = el.getAttribute('data-key-variant-quantities') || '';
  if (qtysRaw) {
    var parsedQtys = qtysRaw.split(',').map(function (q) { return parseInt(q, 10); }).filter(function (q) {
      return Number.isFinite(q) && q > 0;
    });
    if (parsedQtys.length) packQty = parsedQtys[0];
  }
  if (idsRaw && qtysRaw) {
    var ids = idsRaw.split(',');
    var qtys = qtysRaw.split(',');
    ids.forEach(function (id, i) {
      var q = parseInt(qtys[i], 10);
      if (id && Number.isFinite(q) && q > 0) qtyByVariantId[String(id)] = q;
    });
  }

  var rows = [];
  entries.forEach(function (entry) {
    if (!entry || !entry.name || entry.value == null || entry.value === '') return;
    var qty = packQty;
    if (entry.variantId != null && entry.variantId !== '') {
      qty = qtyByVariantId[String(entry.variantId)] || packQty;
    }
    qty = qty * parentQty;
    var unitCents = Number(entry.price);
    if (!Number.isFinite(unitCents) || unitCents < 0) unitCents = 0;
    var optionValue = String(entry.value)
      .replace(/\s*\(\s*included\s*\)\s*/gi, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
    if (!optionValue) return;
    rows.push({
      name: String(entry.name),
      value: optionValue,
      qty: qty,
      lineCents: unitCents * qty
    });
  });
  return rows;
}

function renderKeyDrawerChildRows(parentItem, rows) {
  var next = parentItem.nextElementSibling;
  if (
    next &&
    next.classList &&
    next.classList.contains('key-option-child-item')
  ) {
    return;
  }
  while (
    next &&
    next.classList &&
    next.classList.contains('cart__product-child-item')
  ) {
    var remove = next;
    next = next.nextElementSibling;
    remove.remove();
  }

  if (!rows.length) return;

  var html = rows
    .map(function (row, index) {
      var title = (row.name + ' – ' + row.value).replace(/\s+/g, ' ').trim();
      var lastClass = index === rows.length - 1 ? ' last_child_item_border' : '';
      var price =
        row.lineCents > 0 ? '+$' + (row.lineCents / 100).toFixed(2) : '';
      return (
        '<div class="cart__product-child-item child_item key-option-child-item' +
        lastClass +
        '">' +
        '<div class="cart__product">' +
        '<div class="has_parent_item">' +
        '<div class="has_parent_item_details">' +
        '<div class="cart__product-details-top-wrap">' +
        '<div class="cart__product-details-top-text">' +
        '<h3>' +
        escapeCartHtml(title) +
        '<em>Qty: ' +
        escapeCartHtml(String(row.qty)) +
        '</em></h3>' +
        '</div></div>' +
        '<div class="cart__product-details-bottom">' +
        '<div class="cart__product-price has_parent_item_price">' +
        escapeCartHtml(price) +
        '</div></div>' +
        '</div></div></div></div>'
      );
    })
    .join('');

  parentItem.insertAdjacentHTML('afterend', html);
}

function renderKeyCartPageChildRows(parentItem, rows) {
  var list = parentItem.querySelector('.CartItem__KeyChildList');
  if (!list) return;
  if (list.getAttribute('data-key-painted') === '1') return;

  if (!rows.length) {
    list.setAttribute('data-key-painted', '1');
    return;
  }

  list.innerHTML = rows
    .map(function (row, index) {
      var title = (row.name + ' – ' + row.value).replace(/\s+/g, ' ').trim();
      var lastClass = index === rows.length - 1 ? ' last_child_item_border' : '';
      var price =
        row.lineCents > 0 ? '+$' + (row.lineCents / 100).toFixed(2) : '';
      return (
        '<div class="CartItem--child cart__product-child-item child_item key-option-child-item' +
        lastClass +
        '">' +
        '<div class="has_parent_item_details">' +
        '<h2 class="CartItem__Title Heading">' +
        escapeCartHtml(title) +
        '<em>Qty: ' +
        escapeCartHtml(String(row.qty)) +
        '</em></h2>' +
        '<span class="CartItem__ChildPrice">' +
        escapeCartHtml(price) +
        '</span></div></div>'
      );
    })
    .join('');

  list.setAttribute('data-key-painted', '1');
}

function renderKeyCartOptions(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('[data-key-all-options]').forEach(function (el) {
    var rows = parseKeyCartEntries(el);
    if (!rows.length) return;

    if (el.classList.contains('cart__product-item') || (el.closest && el.closest('.dv-custom-cart'))) {
      var drawerParent = el.classList.contains('cart__product-item')
        ? el
        : el.closest('.cart__product-item');
      if (drawerParent) {
        renderKeyDrawerChildRows(drawerParent, rows);
        return;
      }
    }

    if (el.classList.contains('CartItem--parent') || el.classList.contains('CartItem')) {
      var cartParent = el.classList.contains('CartItem--parent')
        ? el
        : el.closest('.CartItem--parent');
      if (cartParent) {
        renderKeyCartPageChildRows(cartParent, rows);
        return;
      }
    }

    el.innerHTML = rows
      .map(function (row) {
        var value = row.value;
        if (row.qty > 1 && !/\sx\s*\d+\s*$/i.test(value)) value += ' x ' + row.qty;
        if (row.lineCents > 0) value += ' (+$' + (row.lineCents / 100).toFixed(2) + ')';
        return (
          '<li class="CartItem__Property"><span>' +
          escapeCartHtml(row.name) +
          ':</span> ' +
          escapeCartHtml(value) +
          '</li>'
        );
      })
      .join('');
  });
}

function cartUpdate() {
    $.getJSON('/cart.js', function(cart) {
    var cartDrawer = $('.dv-custom-cart');
    var cartDrawerOverlay = $('.c_cart_drawer_overlay');
    cartDrawer.addClass('active');
    cartDrawerOverlay.addClass('active');
    $('.cart_item_count').text(cart.item_count);
    cartUpdateData();
  });
}
function cartUpdateData() {
  fetch('/?section_id=dv-custom-cart')
    .then(response => response.text())
    .then(cartData => {
        setTimeout(function() {
            if (typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
                BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
            }
        }, 200);
      var cartHtml = $(cartData);
      var cartWrapper = $('.cart__wrapper', cartHtml);
      $('.cart__wrapper').replaceWith(cartWrapper);
      renderKeyCartOptions(document.querySelector('.dv-custom-cart') || document);
        if ($('.cart__product-add-items').length) {
        $('.cart__product-add-items').slick({
          dots: true,
          arrows: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: false
        });
      }
    })
    .catch(err => console.error("Error while updating", err));
}

// Initial paint (drawer + cart page) and re-run after cart page AJAX refresh
$(function () {
  function paintKeyCartOptions() {
    renderKeyCartOptions(document);
  }
  paintKeyCartOptions();

  document.querySelectorAll('[data-section-type="cart"]').forEach(function (cartSection) {
    var paintTimer = null;
    new MutationObserver(function () {
      clearTimeout(paintTimer);
      paintTimer = setTimeout(paintKeyCartOptions, 50);
    }).observe(cartSection, { childList: true, subtree: true });
  });
});
});










// result start


$('.result__items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
});

$('.result__prev-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.result__next-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// result end


// Start formula accordion
$(".formula__faq-header").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".formula__faq-content").slideUp();
    } else {
        $(".formula__faq-content").slideUp();
        $(".formula__faq-header").removeClass("active");
        $(this).addClass("active");
        $(this).next(".formula__faq-content").slideDown();
    }
})

// end formula accordion

// Start Hair Confidence 

            if ($(Window).width() < 768) {
                $('.hair-confidence__items').slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                });
            }


$('.hair-confidence__arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// End Hair Confidence 


// Start Best Seller 


if ($(Window).width() < 768) { 
  $('.c_best_seller_product_grid').slick({ 
    slidesToShow: 1, 
    slidesToScroll: 1, 
    arrows: false, 
    dots: true, 
    infinite: true,
    appendDots: $('.c_pagination_wrapper')
  }); 
}
$('.c_bs_slider_next_wrapper').click(function () { 
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});
$('.c_bs_slider_prev_wrap').click(function () { 
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});

// End Best Seller 

// Start Video Play Pos Formula Area
$('.formula__video-btn').on('click', function () {
    const video = $('.formula__video video').get(0);
    video.play();
    $(this).hide();
    video.setAttribute('autoplay', true);
});
$('.formula__video video').on('click', function () {
    if (this.paused) {
        this.play();
        $('.formula__video-btn').hide();
    } else {
        this.pause();
        $('.formula__video-btn').show();
        this.removeAttribute('autoplay');
    }
})



// collection-product start


if ($(Window).width() < 768) {
    $('.collection-product__wrap').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}


// collection-product end



// popup start


$(".redensyl-power__right").on('click', function () {
    $('body').addClass('popup-show');
})
$(".popup__close").on('click', function () {
    $('body').removeClass('popup-show');
})


// popup end





// Start Update Js 10/13/2025


// Slider For Product Page Testimonial
if ($(Window).width() < 768) {
    $('.testimonial__items, .why-wrok__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
    $('.testimonial__right-arrow, .why-wrok__right-arrow').click(function () {
        $(this).parent().parent().find('.slick-slider').slick('slickNext');
    });
}

// Start Video Play on 
$(document).ready(function() {
    $('.testimonial-card__img').on('click', function() {
        var $videoContainer = $(this); 
        var $video = $videoContainer.find('video'); 
        var $playBtn = $videoContainer.find('.testimonial-card__playbtn'); 
        var isPlaying = $video.attr('playsinline') !== undefined;
        if (isPlaying) {
            $video[0].pause();
            $video.removeAttr('playsinline');
            $video.removeAttr('loop');
            $playBtn.show();
        } else {
            $('.testimonial-card__img').each(function() {
                var $otherVideo = $(this).find('video');
                var $otherPlayBtn = $(this).find('.testimonial-card__playbtn');
                if ($otherVideo.attr('playsinline') !== undefined && $otherVideo[0] !== $video[0]) {
                    $otherVideo[0].pause();
                    $otherVideo.removeAttr('playsinline');
                    $otherVideo.removeAttr('loop');
                    $otherPlayBtn.show();
                }
            });
            $video.attr('playsinline', 'playsinline');
            $video.attr('loop', 'loop'); 
            $video[0].play(); 
            $playBtn.hide(); 
        }
    });
    $('.testimonial-card__playbtn').on('click', function(e) {
        e.stopPropagation();
        $(this).closest('.testimonial-card__img').trigger('click');
    });
});




// Start Study Details Blacked
$(".why-work__study-header").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".why-work__study-content").slideUp();
    } else {
        $(".why-work__study-content").slideUp();
        $(".why-work__study-header").removeClass("active");
        $(this).addClass("active");
        $(this).next(".why-work__study-content").slideDown();
    }
})



$('.inside-card > a').on('click', function () {
    $("body").addClass('popup-shows');
    var popup_title = $(this).data('title');
    var popup_content = $(this).data('content');
    var popup_image = $(this).data('img');
    var popup_video = $(this).data('video');
    $('.inside-popup__top h2').text(popup_title);
    $('.inside-popup__text').html(popup_content);
    console.log(popup_image);
    if(popup_image != ''){
        $('.inside-popup__img').show();
        $('.inside-popup__img img').attr('src', popup_image);
    }else{
        $('.inside-popup__img').hide();
    };

    if(popup_video != ''){
        $('.inside-popup__video').show();
        let videoId = "";
        if (popup_video.includes("watch?v=")) {
            videoId = popup_video.split("v=")[1].split("&")[0];
        }
        else if (popup_video.includes("youtu.be/")) {
            videoId = popup_video.split("youtu.be/")[1].split("?")[0];
        }
        $('.inside-popup__video iframe').attr('src', "https://www.youtube.com/embed/" + videoId);
    }else{
        $('.inside-popup__video').hide();
    }
});
$('.inside-popup__close , .overlay-bg').on('click', function () {
    $("body").removeClass('popup-shows');
});
// Start Popup Video Open
$(document).ready(function () {
    $(".inside-popup__video").each(function () {
        const $container = $(this);
        const $video = $container.find("video");
        const $playBtn = $container.find(".inside-popup__video-btn");
        $playBtn.on("click", function () {
            $video.prop("muted", false);
            $video.get(0).play();
            $playBtn.hide();
        });
        $video.on("click", function () {
            if (this.paused) {
                this.play();
                $video.prop("muted", false);
                $playBtn.hide();
            } else {
                this.pause();
                $playBtn.show();
            }
        });
    });
});


// Start Tab Class all collection page

$(document).ready(function() {
    function updateProductListClass(element) {
        var desktopCount = parseInt($(element).attr('data-desktop-count'), 10);
        if (desktopCount === 4) {
            $(element).addClass('collection-card-tab-desk');
        } else {
            $(element).removeClass('collection-card-tab-desk');
        }
    }
    $('.ProductList').each(function() {
        var self = this;
        updateProductListClass(self);
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'data-desktop-count') {
                    updateProductListClass(self);
                }
            });
        });
        observer.observe(self, { attributes: true });
    });
});


// End Tab Class all collection page


// Start Product Modal Zoom 

$(document).ready(function () {
  var $popup = $('#imageZoomPopup');
  var $img   = $('#zoomedImage');
  var $wrap  = $('#zoomImageWrap');

  var scale = 1, posX = 0, posY = 0;
  var minZoom = 1, maxZoom = 4, step = 0.5;
  var drag = null, pointers = 0, pinchDist = null;

  function isMobile() {
    return $(window).width() < 1024;
  }

  function render() {
    $img.css('transform', 'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')');
  }

  function setZoom(val) {
    scale = Math.min(Math.max(val, minZoom), maxZoom);
    if (scale === minZoom) { posX = 0; posY = 0; }
    render();
  }

  function reset() {
    scale = 1; posX = 0; posY = 0; render();
  }

  function open() {
    if (!isMobile()) return;
    var src = $('.main-product__img-poster .slick-current img').attr('src');
    if (!src) return;
    $img.attr('src', src);
    reset();
    $popup.addClass('active');
    $('body').addClass('zoom-popup-open');
  }

  function close() {
    $popup.removeClass('active');
    $('body').removeClass('zoom-popup-open');
    reset();
  }

  // ---- Open / Close ----
  $(document)
    .on('click', '.main-product__img-zoom > a', function (e) { e.preventDefault(); open(); })
    .on('click', '.image-zoom-popup__close', close)
    .on('keydown', function (e) { if (e.key === 'Escape') close(); });

  $popup.on('click', function (e) { if (e.target === this) close(); });

  $(window).on('resize', function () {
    if (!isMobile() && $popup.hasClass('active')) close();
  });

  // ---- Zoom: buttons + wheel ----
  $(document)
    .on('click', '.image-zoom-popup__zoom-in', function () { setZoom(scale + step); })
    .on('click', '.image-zoom-popup__zoom-out', function () { setZoom(scale - step); });

  $wrap.on('wheel', function (e) {
    e.preventDefault();
    setZoom(scale + (e.originalEvent.deltaY < 0 ? step : -step));
  });

  // ---- Pan: mouse + single-finger touch (Pointer Events দুটোই কভার করে) ----
  $wrap.on('pointerdown', function (e) {
    pointers++;
    if (pointers > 1 || scale <= minZoom) { drag = null; return; }
    drag = { x: e.clientX - posX, y: e.clientY - posY };
    $wrap.addClass('dragging');
  });

  $(document).on('pointermove', function (e) {
    if (!drag || pointers > 1) return;
    posX = e.clientX - drag.x;
    posY = e.clientY - drag.y;
    render();
  });

  $(document).on('pointerup pointercancel', function () {
    pointers = Math.max(0, pointers - 1);
    if (!pointers) { drag = null; $wrap.removeClass('dragging'); }
  });

  // ---- Pinch zoom (two-finger touch) ----
  $wrap.on('touchmove', function (e) {
    var t = e.originalEvent.touches;
    if (t.length !== 2) return;
    e.preventDefault();
    var dist = Math.hypot(t[0].pageX - t[1].pageX, t[0].pageY - t[1].pageY);
    if (pinchDist) setZoom(scale + (dist - pinchDist) * 0.01);
    pinchDist = dist;
  });

  $wrap.on('touchend touchcancel', function (e) {
    if (e.originalEvent.touches.length < 2) pinchDist = null;
  });
});


// End Product Modal Zoom





$(function () {

    const $currency = $('.custom-currency-select select[name="currency_code"]');
    const savedCurrency = localStorage.getItem('selectedCurrency');
    if (savedCurrency) {
        $currency.val(savedCurrency);
    }
    $currency.on('change', function () {
        localStorage.setItem('selectedCurrency', this.value);
        this.form.submit();
    });

});


